import { TransactionsListReportRequestModel } from '../api/models/TransactionsListReportRequestModel';
import { TransactionListTypeNum, TransactionsListReportFormModel } from '../models';

export const dataFormToRequest = (
  data: TransactionsListReportFormModel
): TransactionsListReportRequestModel => {
  return {
    // date: data.date,
    from: data.from,
    to: data.to,
    system_posting: data.system_posting,
    cash_register_ids: data.cash_register_ids,
    cashier_ids: data.cashier_ids,
    operation_id: data.operation_id,
    billing: data.billing,
    ...(data.type !== TransactionListTypeNum.ALL ? { type: data.type } : {}),
    order_by: data.order_by,
    charge_group_ids: data.charge_group_ids,
    billing_group_ids: data.billing_group_ids,
    charge_code_ids: data.charge_code_ids,
    file_type: data.file_type,
  };
};
